import React, { ReactElement, InputHTMLAttributes } from 'react';
import parse from 'html-react-parser';

import { DataCollectionValuesKey } from '../../../hooks';

interface FormControlProps {
    name: DataCollectionValuesKey;
    id: string;
    props?: InputHTMLAttributes<HTMLInputElement>;
    className?: string;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    onBlur: React.FocusEventHandler<HTMLInputElement>;
    value: string;
    label: string;
    image?: string;
    checked?: boolean;
}

const FormRadio = ({ name, id, className, label, image, ...props }: FormControlProps): ReactElement<'div'> | null => {
    const customClass = className || '';
    const containerClass = ['wiz-form-radio', customClass].join(' ');

    return (
        <div className={containerClass}>
            <input id={id} type="radio" name={name} className="wiz-form-radio__input" {...props} />
            <label htmlFor={id} className="wiz-form-radio__label">
                {image && <img src={image} alt="" width={140} className={'wiz-form-radio__img'} />}
                <div className="wiz-form-radio__title">
                    <span>{parse(label)}</span>
                </div>
            </label>
        </div>
    );
};

export default FormRadio;
